import { render } from "./BillsReceipted.vue?vue&type=template&id=85aafe6a&scoped=true"
import script from "./BillsReceipted.vue?vue&type=script&lang=js"
export * from "./BillsReceipted.vue?vue&type=script&lang=js"

import "./BillsReceipted.vue?vue&type=style&index=0&id=85aafe6a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-85aafe6a"]])

export default __exports__